import { action } from 'src/store/common';
import { IPlacement } from 'src/typings/placement';

export const ActionTypes = {
  SET_PLACEMENT_DATA: '[PLACEMENT]SET_PLACEMENT_DATA',
  RESET_PLACEMENT_DATA: '[PLACEMENT]RESET_PLACEMENT_DATA',
};
export const PlacementActions = {
  setPlacementData: action<IPlacement>(ActionTypes.SET_PLACEMENT_DATA),
  resetPlacementData: action(ActionTypes.RESET_PLACEMENT_DATA),
};
